import React from 'react';
import { Link } from 'react-router-dom';
import { useSiteSettings } from '../SiteSettingsContext';
import { getMergedStoreCopy } from '../storeCopy';

const ICONS = {
  ship: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.75" aria-hidden>
      <path d="M3 7h11v8H3zM14 10h4l3 3v2h-7V10zM6 19a2 2 0 100-4 2 2 0 000 4zm10 0a2 2 0 100-4 2 2 0 000 4z" />
    </svg>
  ),
  lock: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.75" aria-hidden>
      <rect x="5" y="11" width="14" height="10" rx="2" />
      <path d="M8 11V8a4 4 0 118 0v3" />
    </svg>
  ),
  craft: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.75" aria-hidden>
      <path d="M12 3l2 4 4 .5-3 3 .8 4-3.8-2.2L12 17l-3.2-2.2L5 15.3l.8-4-3-3 4-.5L12 3z" />
    </svg>
  ),
};

export default function StoreTrustBadges({ compact = false }) {
  const { settings: site } = useSiteSettings();
  const store = getMergedStoreCopy(site);
  const items = [
    { key: 'ship', icon: ICONS.ship, text: store.trust_badge_1 || 'Ships across India' },
    { key: 'lock', icon: ICONS.lock, text: store.trust_badge_2 || 'Secure checkout' },
    { key: 'craft', icon: ICONS.craft, text: store.trust_badge_3 || 'Handcrafted quality' },
  ];
  return (
    <div className={`store-trust-wrap${compact ? ' store-trust-wrap--compact' : ''}`}>
      <ul className={`store-trust${compact ? ' store-trust--compact' : ''}`}>
        {items.map((item) => (
          <li key={item.key} className="store-trust__item">
            <span className="store-trust__icon">{item.icon}</span>
            <span>{item.text}</span>
          </li>
        ))}
      </ul>
      {!compact ? (
        <p className="store-trust-policies small text-muted mb-0">
          <Link to="/policies/shipping">Shipping</Link>
          {' · '}
          <Link to="/policies/returns">Returns</Link>
          {' · '}
          <Link to="/policies/privacy">Privacy</Link>
        </p>
      ) : null}
    </div>
  );
}
